import {
  prepareCandidateRequest,
  retryWithFreshCandidateCapability,
} from 'candidate-app/apiTransport';
import { applyLegacyTranscriptHeaders } from 'share-links/legacyTranscriptTransport';
import type { InternalAxiosRequestConfig } from 'axios';

import { getAuthHeaders } from './authHeaders';
import { handleAuthFailure } from './authFailure';
import type { AppTransportPolicy } from './transportTypes';

const prepareRequest = (config: InternalAxiosRequestConfig) => {
  applyLegacyTranscriptHeaders(config);
  return prepareCandidateRequest(config);
};

// All apps previously shared this combination, including staff credentials on
// candidate pages. Keep it explicit while separating ownership; restricting
// which credentials an app may send is a separate authentication change.
const compatibilityBehavior: Omit<AppTransportPolicy, 'app'> = {
  getAuthHeaders: () => getAuthHeaders(),
  prepareRequest,
  retryRequest: retryWithFreshCandidateCapability,
  handleAuthFailure: (response, headers) =>
    handleAuthFailure(response, headers),
};

export const recruiterTransportPolicy: AppTransportPolicy = {
  app: 'recruiter',
  ...compatibilityBehavior,
};

export const interviewTransportPolicy: AppTransportPolicy = {
  app: 'interview',
  ...compatibilityBehavior,
};

export const externalAgentTransportPolicy: AppTransportPolicy = {
  app: 'external-agent',
  ...compatibilityBehavior,
};

export const internalTransportPolicy: AppTransportPolicy = {
  app: 'internal',
  ...compatibilityBehavior,
};

export const jobBoardTransportPolicy: AppTransportPolicy = {
  app: 'jobboard',
  ...compatibilityBehavior,
};
